export function AddToBaseList(baseList, addPair) {
  // Baselist sorts children behind their parent...
  var n = baseList.length;
  for (var i = 0; i < n; i++) {
    var s = baseList[i];

    var c1 = s.fSerialDBObj;
    var p1 = c1.GetParentID();
    var c2 = addPair.fSerialDBObj;
    var p2 = c2.GetParentID();

    if (p1 == p2) {
      var index1 = c1.GetChildIndex();
      var index2 = c2.GetChildIndex();
      if (index2 <= index1) {
        baseList.splice(i, 0, addPair);
        return;
      }
    }
  }

  baseList.push(addPair);
}
